import {MarketerRepository} from '../repository/MarketerRepository';
import {UpdateMarketerPasswordRequest} from '../models/UpdateMarketer';

export class UpdateMarketerPasswordUseCase {
  constructor (private marketerRepository: MarketerRepository) {}

  async execute (id: number, passwordData: UpdateMarketerPasswordRequest): Promise<any> {
    return await this.marketerRepository.updatePassword(id, passwordData);
  }
}
